import { idb } from "utils"
import * as types from "../types/categories"
import { getAllCategories } from "services"
import { store } from "@redux/store"

export const fetchCategories = () => (
  async (dispatch) => {
    const branchId =
      store.getState().userAccountInfo.branchId

    try {
      const categoriesFromDatabase =
        await idb.getAllItemsFromDatabase(
          branchId,
          "categories"
        )

      dispatch({
        type: types.FETCH_CATEGORIES,
        data: categoriesFromDatabase
      })

      const response = await getAllCategories()

      dispatch({
        type: types.FETCH_CATEGORIES,
        data: response
      })

      idb.saveItemsToDatabase(
        branchId,
        "categories",
        response
      )
    } catch (err) {
      console.log(err)
    }
  }
)

export const createCategory = (newCategory) => {
  const branchId =
    store.getState().userAccountInfo.branchId

  idb.saveItemsToDatabase(
    branchId,
    "categories",
    [newCategory]
  )

  return {
    type: types.ADD_CATEGORY,
    newCategory
  }
}

export const updateCategory = (newCategory) => {
  const branchId =
    store.getState().userAccountInfo.branchId

  idb.saveItemsToDatabase(
    branchId,
    "categories",
    [newCategory]
  )

  return {
    type: types.UPDATE_CATEGORY,
    newCategory
  }
}

export const deleteCategory = (categoryId) => {
  const branchId =
    store.getState().userAccountInfo.branchId

  idb.deleteItemsFromDatabase(
    branchId,
    "categories",
    [categoryId]
  )

  return {
    type: types.DELETE_CATEGORY,
    categoryId
  }
}

export const clearCategories = () => ({
  type: types.CLEAR_CATEGORIES
})